import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { MetaThemeColorService, NotificationService } from "@core";
import { AbstractNotificationDirective } from "../abstract/abstract-notification.directive";

@Component({
  selector: "app-notifications",
  standalone: true,
  imports: [],
  templateUrl: "./notification-container.component.html",
  styleUrl: "./notification-container.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationContainerComponent {
  showingNotification = false;

  @ViewChild("notificationFrame", { read: ViewContainerRef }) notificationFrame!: ViewContainerRef;

  constructor(
    private _notificationService: NotificationService,
    private _metaThemeColorService: MetaThemeColorService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _elementRef: ElementRef,
  ) {
    this._notificationService.toShowComponent$.subscribe((component) => {
      if (component) {
        this.notificationFrame.clear();

        const componentInstance = new component() as AbstractNotificationDirective;
        this._metaThemeColorService.setDemandOnMetaColor(componentInstance.colorVariable);

        this.notificationFrame.createComponent(component);
        this._elementRef.nativeElement.classList.add("notification-active");
        this.showingNotification = true;
        this._changeDetectorRef.detectChanges();
      } else {
        this.notificationFrame.clear();
        this._metaThemeColorService.setDemandOnMetaColor(null);
        this._elementRef.nativeElement.classList.remove("notification-active");
        this.showingNotification = false;
        this._changeDetectorRef.detectChanges();
      }
    });
  }
}
